import  * as React from "react";
import { observer } from "mobx-react";
import { IOptimizerBarsParams } from "./IOptimizerBarsParams";

@observer
export class OptimizerBars extends React.Component<IOptimizerBarsParams>{
    constructor(props: IOptimizerBarsParams) {
        super(props, undefined);
    }

    render() {
        return <div className="OptimizerBars">
                   <div className="row optimizer-bar-wrapper">
                       {this.props.clubType === "Driver" &&
                           <div className="hidden-xs col-sm-1"></div>
                       }
                       <div className="optimizers-wrapper">
                           { this.props.children }
                       </div>
                       {this.props.clubType === "Driver" &&
                           <div className="hidden-xs col-sm-1"></div>
                       }
                   </div>
               </div>;
    }
}
